import {AfterViewInit, Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AppSetting} from "./app-settings.models";
import {AppSettingsService} from "./app-settings.service";

@Component({
    selector: 'app-settings',
    templateUrl: './app-settings.component.html',
    styleUrls: ['./app-settings.component.css']
})
export class AppSettingsComponent implements AfterViewInit {

    appSettings: Array<AppSetting>;
    isLoadingResults = true;
    progress = false;
    prevMonthDays: string[] = Array(31).fill(0).map((x, i) => '' + (i + 1));

    constructor(public route: ActivatedRoute,
                public router: Router,
                public appSettingsService: AppSettingsService,
                private _snackBar: MatSnackBar) {
    }

    ngAfterViewInit() {
        this.appSettingsService.findAll().subscribe(
            appSettings => {
                this.appSettings = appSettings;
                this.isLoadingResults = false;
            },
            error => {
                console.log(error);
                this.isLoadingResults = false;
            });
    }

    udpate() {
        this.progress = true;
        this.appSettingsService.update(this.appSettings)
            .subscribe(
                response => {
                    this.progress = false;
                    this._snackBar.open('App settings were successfully updated!', 'Close', {
                        duration: 5000,
                    });
                },
                error => {
                    this.progress = false;
                    console.log(error);
                });
    }
}
